<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <gj-country-server-select
              v-model="filter.countryMarketValue"
              :external-country="countryValue"
              :external-market="marketValue"
          ></gj-country-server-select>
          <gj-select
              v-model="filter.spApiAuthStatus"
              :options="MarketEnum.spApiAuthStatusOption"
              placeholder="店铺授权状态"
              width="120px"
          ></gj-select>
          <gj-select
              v-model="filter.adsAuthStatus"
              :options="MarketEnum.adsAuthStatusOption"
              placeholder="广告授权状态"
              width="120px"
          ></gj-select>
          <gj-select
              ref="statusSelect"
              v-model="filter.status"
              :options="MarketEnum.statusOption"
              placeholder="店铺状态"
          ></gj-select>
        </app-filter-group>
      </template>
      <template #operate-group>
        <!--        <gj-button type="primary" @click="add">店铺授权</gj-button>-->
        <gj-button type="primary" @click="add2(), userGuideNextStep()">店铺授权</gj-button>
        <span style="font-size: 12px;color: #999;display: inline-block;" v-if="userInfo&&userInfo.freeOrder === true">
          (新店孵化大礼包，限时免费送—每日订单量小于100单的店铺免扣订单量)
        </span>
      </template>
      <template #tool-group>
        <gj-tool-group
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <!--        :pagination="pagination"-->
        <gj-table
            :index="false"
            adaptParent
            :name="tableName"
            :loading="loading"
            :span-method="spanMethod"
            :data="mapTableData"
            :columns="columns"
            :show-overflow="false"
            :row-class-name="rowClassName"
            @page-change="$gjNoticeQuery">
          <template v-slot:marketName="{ row }">
            <template v-if="row.dataType === 'area'">
              <div v-gutter="32">
                <span style="color: #444444;">{{ row.areaName }}</span>
                <span><span style="color: #888">卖家编号：</span>{{ row.sellerId }}</span>
                <span v-if="row.naUnifiedAccount">
                  <strong style="margin-right: 8px;">北美联合账户</strong><gj-button type="text">取消</gj-button>
                </span>
                <span v-else-if="false && row.region === 'na'">
                 <gj-button type="text">设置北美联合账户</gj-button>
                </span>
              </div>
            </template>
            <template v-else>
              <gj-tooltip :text-line="1" :content="row.marketName">
                <gj-edit-input
                    :ellipsis="1"
                    :value="row.marketName"
                    :item="row"
                    table-cell-edit
                    :validator="isMeaningful"
                    :on-confirm="updateMarketName"
                    :pop-title="'店铺名称'">
                  {{ row.marketName }}
                </gj-edit-input>
              </gj-tooltip>

            </template>
          </template>

          <template v-slot:warehouseName="{ row }">
            <gj-tooltip :text-line="1" :content="row.warehouseName">
              {{row.warehouseName}}
            </gj-tooltip>
          </template>


          <!--          店铺授权-->
          <template v-slot:spApiAuthStatus="{row}">
            <template v-if="row.spApiAuthStatus === 'Expired'">
              <gj-text-alert
                  type="warning"
                  :gutter="5"
                  font-size="12px"
                  font-color="inherit"
                  icon-font-size="20px">
                授权过期，请至后台刷新授权
              </gj-text-alert>
            </template>
            <template v-else-if="row.spApiAuthStatus === 'Success'">
              <span class="colorGreen">授权成功</span>&nbsp;
              <gj-button
                  type="text"
                  :loading="row.reMarketAuthLoading"
                  @click="reMarketAuth(row)"
              >重新授权
              </gj-button>
            </template>
            <template v-else-if="row.spApiAuthStatus === 'Fail'">
<!--              <gj-text-alert-->
<!--                  type="error"-->
<!--                  :gutter="5"-->
<!--                  icon-font-size="20px">-->
              <span  class="colorRed">授权失败</span>&nbsp;
                <gj-button type="text" :loading="row.reMarketAuthLoading" @click="reMarketAuth(row)">
                  重新授权
                </gj-button>
<!--              </gj-text-alert>-->
            </template>
          </template>

          <!--          邮箱配置-->
          <template v-slot:mailSetting="{row}">
            <template v-if="row.email && row.email.account">
              <template v-if="row.email.status !== 'Normal'">
<!--                <gj-tooltip :content="getMailAuthErrorMsg(row.email.status)">-->
<!--                  <gj-text-alert-->
<!--                      type="error"-->
<!--                      :gutter="5"-->
<!--                      icon-font-size="16px"-->
<!--                  >-->
<!--                    <span class="colorRed" style="font-size: 12px; margin-right: 10px">{{ row.email.account }}</span>-->
<!--                  </gj-text-alert>-->
<!--                </gj-tooltip>-->
                <div>
                  <span class="colorRed">{{ row.email.account }}</span>&nbsp;
                  <gj-button style="padding: 0" type="text" @click="editEmail(row)">重新绑定</gj-button>
                  <gj-button style="padding: 0" type="text" @click="unbindEmail(row.email.id)">解绑</gj-button>
                </div>
                <div class="colorRed">{{getMailAuthErrorMsg(row.email.status)}}</div>
              </template>
              <template v-else>
                <span class="colorGreen">{{ row.email.account }}</span>&nbsp;
<!--                <gj-button type="text" @click="editEmail(row)">编辑</gj-button>-->
                <gj-button type="text" @click="unbindEmail(row.email.id)">解绑</gj-button>
              </template>
            </template>
            <template v-else>
              <gj-button type="text" @click="bindEmail(row), userGuideNextStep()">绑定邮箱</gj-button>
            </template>
          </template>

          <!--          广告授权-->
          <template v-slot:ad-auth="{ row }">

            <template v-if="row.adsAuthStatus === 'Unauthorized'">
              <gj-button type="text" @click="adAuth(row), userGuideNextStep()">待授权</gj-button>
            </template>

            <template v-else-if="row.adsAuthStatus === 'Exception'">
              <span class="colorRed">授权异常，请重新授权</span>&nbsp;
              <gj-button type="text" @click="adAuth(row), userGuideNextStep()">重新授权</gj-button>
            </template>

            <template v-else-if="row.adsAuthStatus === 'Fail'">
<!--              <gj-text-alert type="error" :gutter="5" icon-font-size="16px">-->
                <span class="colorRed">授权失败</span>&nbsp;
                <gj-button type="text" @click="adAuth(row), userGuideNextStep()">重新授权</gj-button>
<!--              </gj-text-alert>-->
            </template>

            <template v-else-if="row.adsAuthStatus === 'NotOpen'">
              未开通
            </template>

            <template v-else-if="row.adsAuthStatus === 'Success'">
              <span class="colorGreen">授权成功</span>&nbsp;
              <gj-button type="text" @click="adAuth(row), userGuideNextStep()">重新授权</gj-button>
            </template>

            <template v-else-if="row.adsAuthStatus === 'yichang'">
              <div>
                <span class="colorRed">授权异常</span>&nbsp;
                <gj-button type="text" style="padding: 0" @click="adAuth(row), userGuideNextStep()">重新授权</gj-button>
              </div>
              <div class="colorRed">
                账户异常，请查看后台处理
              </div>
            </template>

            <template v-else>-</template>

          </template>

          <template v-slot:status="{row}">
            <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                    :color="row.status | optionColor(MarketEnum.statusOption)">
              {{ row.status | optionText(MarketEnum.statusOption) }}
            </gj-tag>
          </template>

          <template v-slot:op="{ row }">
            <gj-button
              v-if="row.status === 'Active'"
              type="text"
              @click="pause(row)">
              停用
            </gj-button>
            <gj-button
                v-if="row.status === 'Inactive'"
                type="text"
                @click="enable(row)">
              启用
            </gj-button>
            <gj-button
                type="text"
                @click="deleteItem(row)">
              删除
            </gj-button>
            <gj-button
                type="text"
                @click="viewLog(row)">
              日志
            </gj-button>
          </template>
        </gj-table>
      </template>
      <template v-if="userGuideState" #base-content>
        <new-user-guide ref="newUserGuide" @closeModal="closeModal"></new-user-guide>
      </template>
    </app-base-main>
</template>

<script>
import {isMeaningfulMixin, queryMixin, responseMixin, userGuideMixin} from "@/minxins";
import {MarketEnum} from "./enum";
import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
import {countryOption} from "@/utils/options";
import {optionText} from "@/filters";
import AppAddMarketModal from "./modal/add-market-modal";
import AppAdAuthorizeModal from "./modal/ad-authorize-modal";
import AppReauthMarketModal from "./modal/reauth-market-modal";
import AppMailAuthorizeModal from './modal/mail-authorize-modal';
import AppMailEditModal from './modal/mail-edit-modal';
import AppVideoModal from "./modal/video-modal";
import addSteoModal from "./modal/add-step-modal";
import NewUserGuide from "./components/new-user-guide"
import {disableMarket, enableMarket, getMarketList, updateMarketName, getAdsSupplyCountryCode, deleteMarket} from "@/api/system";
import {unbindEmail} from "@/api/crm";
import {getAllAuthCountries, getAllAuthMarkets} from "@/api/common";
import {mapGetters} from "vuex";

export default {
  name: "app-market",
  props: ['marketShowVideo'],
  mixins: [queryMixin, responseMixin, isMeaningfulMixin, userGuideMixin],
  components: { NewUserGuide },
  watch: {
    $route: {
      immediate: true,
      handler(value) {
        if (value && value.query && value.marketId) {
          this.isInitParams = false;
          this.filter.countryMarketValue = {
            marketIds: [value.query.marketId],
            countryIds: [],
          };
          this.filter.spApiAuthStatus = null;
          this.filter.adsAuthStatus = null;
          this.filter.status = null;
        }
      }
    },
    marketShowVideo: function (val) {
      //强制引导通信店铺授权页
      // this.showVideo();
    }
  },
  created() {
    getAllAuthMarkets().then((res) => {
      this.marketValue = res.filter(r=>r.status==='Active').concat(res.filter(r=>r.status!=='Active'));
    });
    getAllAuthCountries().then((res) => {
      this.countryValue = res;
    });
    getAdsSupplyCountryCode().then(res=>{
      this.adsSupplyCountryCode = res;
    })
  },
  mounted() {
    if(isMeaningless(this.$route.query.timeStamp)){
      // this.showVideo()
    }
  },
  activated() {
    if(this.$route.query.marketId) {
      let countryMarketValue = {
        countryIds: [],
        marketIds: [this.$route.query.marketId]
      }
      this.filter.countryMarketValue = countryMarketValue
      this.$emit('query')
    }
  },
  data() {
    return {
      adsSupplyCountryCode:[],

      tableName: 'market',
      tableData: [],
      columns: [
        {id: 'marketName', header: '店铺名称', field: 'slot:marketName', minWidth: '70px'},
        {id: 'countryCode', header: '国家', field: 'option:countryCode', width: '100px', options: countryOption},
        {
          id: 'warehouseName',
          header: '仓库名称',
          field: 'slot:warehouseName',
          minWidth: '70px',
          help: '仓库名称中的前缀-店铺名称，默认以您所授权该卖家编号下的第一个店铺名称'
        },
        {id: 'spApiAuthStatus', header: '店铺授权', field: 'slot:spApiAuthStatus', minWidth: '70px'},
        {id: 'mailSetting', header: '邮箱配置', field: 'slot:mailSetting', minWidth: '140px'},
        {id: 'adsAuthStatus', header: '广告授权', field: 'slot:ad-auth', minWidth: '70px'},
        {id: 'status', header: '状态', field: 'slot:status', width: '60px', options: MarketEnum.statusOption},
        {id: 'spApiAuthTime', header: '店铺授权时间', field: 'spApiAuthTime', width: '150px'},
        {id: 'op', header: '操作', field: 'slot:op', minWidth: '140px', notCustomColumn: true},
      ],
      filter: {
        countryMarketValue: null,
        spApiAuthStatus: null,
        adsAuthStatus: null,
        status: null
      },
      MarketEnum: MarketEnum,
      marketValue: [],
      countryValue: [],

      //授权新店铺时邮件组件props
      marketItem: {
        region: '1',
        countryCode: '2',
        marketId: '3',
        marketName: '4',
        items: [
          {countryCode: '1'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','marketAuthType']),
    showStoreMask (){
      let marketAuth = this.marketAuthType.find(r=> r.authType==='market');
      if(marketAuth){
        return marketAuth.auth
      }else {
        return false
      }
    },
    mapTableData() {
      let tableData = [];
      this.tableData.forEach(item => {
        item.dataType = 'area';
        tableData.push(item);
        if (item.markets) {
          tableData = tableData.concat(item.markets);
        }
      });
      return tableData;
    },
  },
  methods: {
    showVideo(){
      if(!this.showStoreMask){
        this.$gjCreate(AppVideoModal)
      }
    },
    $gjQueryInitParams() {
      let countryMarketValue = null
      if(this.$route.query.marketId) {
        countryMarketValue = {
          countryIds: [],
          marketIds: [this.$route.query.marketId]
        }
      }
      return {
        tableName: 'market',
        tableData: [],
        columns: [
          {id: 'marketName', header: '店铺名称', field: 'slot:marketName', minWidth: '70px'},
          {id: 'countryCode', header: '国家', field: 'option:countryCode', minWidth: '70px', options: countryOption},
          {id: 'warehouseName', header: '仓库名称', field: 'slot:warehouseName', minWidth: '70px', help: '仓库名称中的前缀-店铺名称，默认以您所授权该卖家编号下的第一个店铺名称'},
          {id: 'spApiAuthStatus', header: '店铺授权', field: 'slot:spApiAuthStatus', minWidth: '70px'},
          {id: 'mailSetting', header: '邮箱配置', field: 'slot:mailSetting', minWidth: '140px'},
          {id: 'adsAuthStatus', header: '广告授权', field: 'slot:ad-auth', minWidth: '70px'},
          {id: 'status', header: '状态', field: 'option(plain):status', minWidth: '70px', options: MarketEnum.statusOption},
          {id: 'spApiAuthTime', header: '店铺授权时间', field: 'spApiAuthTime', minWidth: '70px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '140px', notCustomColumn: true},
        ],
        filter: {
          countryMarketValue: countryMarketValue,
          spApiAuthStatus: null,
          adsAuthStatus: null,
          status: null
        }
      };
    },
    $gjQuery() {
      // 构造查询参数
      const params = {
        countryCodes: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.countryIds : null,
        marketIds: isMeaningful(this.filter.countryMarketValue) ? this.filter.countryMarketValue.marketIds : null,
        spApiAuthStatus: defaultVal(this.filter.spApiAuthStatus, null),
        adsAuthStatus: defaultVal(this.filter.adsAuthStatus, null),
        status: defaultVal(this.filter.status, null),
      };
      // 查询
      this.loading = true;
      getMarketList(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = (data || []).map(item => ({
                region: item.region,
                areaName: optionText(item.region, MarketEnum.areaOption),
                sellerId: item.sellerId,
                naUnifiedAccount: item.naUnifiedAccount,
                markets: item.items.map(e => ({
                  ...e,
                  region: item.region,
                  parentItem: item
                }))
              }));
            }
          })
          .complete(() => {
            this.loading = false;
          })
    },
    reMarketAuth(row) {
      const item = {
        region: row.region,
        countryCode: row.countryCode,
        marketId: row.id,
        marketName: row.marketName,
        items: row.parentItem.items
      };
      this.$gjCreate(AppReauthMarketModal, {
        props: {
          market: row,
          marketItem: item
        },
        on: {
          authed: () => {
            this.$gjResetPage();
          }
        }
      });
    },
    updateMarketName(name, row, closeEditor, closeLoading) {
      updateMarketName({
        id: row.id,
        name,
      })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              closeEditor();
              this.$gjResetPage();
            });
          })
          .complete(() => closeLoading());
    },
    spanMethod({row, column, rowIndex, columnIndex}) {
      if (row.dataType === 'area') {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 9
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    rowClassName({row}) {
      if (row.dataType === 'area') {
        return 'gj-table-parent-row';
      }
    },
    deleteItem(row) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '删除确认',
          content: `<span class="info-content">您是否确认删除【${row.marketName}:${optionText(row.countryCode, countryOption)}】？</span><br>
                    <span class="colorRed">注意：删除店铺后数据将不会保存，再次重新授权，历史数据也无法恢复，请谨慎操作。</span>`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            deleteMarket(row.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
          }
        }
      });
    },
    pause(row) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '停用确认',
          content: `<span class="info-content">确认停用 店铺【${row.marketName}】 国家【${optionText(row.countryCode, countryOption)}】？</span><br>
                    <span class="colorRed">请谨慎操作，停用后店铺数据将停止同步！再次启用将按照店铺首次授权进行历史数据同步，可能会损失一部分数据。</span>`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            disableMarket(row.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
          }
        }
      });
    },
    enable(row) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          content: `<span style="font-size: 14px;line-height: 1;">确认启用 店铺【${row.marketName}】 国家【${optionText(row.countryCode, countryOption)}】？</span>`
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            enableMarket(row.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  });
                })
                .complete(() => modal.confirmLoading = false);
          }
        }
      });
    },
    add() {
      this.$gjCreate(AppAddMarketModal, {
        on: {
          authed: () => {
            this.$gjResetPage();
          }
        }
      });
    },
    add2() {
      this.$gjCreate(addSteoModal, {
        props: {
          marketItem: this.marketItem,
          adsSupplyCountryCode:this.adsSupplyCountryCode
        },
        on: {
          authed: () => {
            this.$gjResetPage();
          },
          userGuide: () => {
            // 引导用户
            this.userGuideNextStep()
          },
          close: () => {
            if(this.userGuideState) {
              // 关闭引导用户
              this.userGuideCancel()
            }
          },
        }
      });
    },
    adAuth(row) {
      this.adAuthModal = this.$gjCreate(AppAdAuthorizeModal, {
        props: {
          market: row,
          marketItem: {
            items: row.parentItem.items,
            sellerId: row.parentItem.sellerId
          },
          adsSupplyCountryCode:this.adsSupplyCountryCode
        },
        on: {
          authed: () => {
            this.$gjResetPage();
          },
          userGuide: () => {
            // 引导用户
            this.userGuideNextStep()
          },
          close: () => {
            if(!this.isAutoAdAuthModal && this.userGuideState) { // 非自动关闭弹框才需要退出用户指引模式
              // 关闭引导用户
              this.userGuideCancel()
              this.isAutoAdAuthModal = false
            }
          },
        }
      });
    },
    closeModal() {
      if(this.adAuthModal)  {
        this.isAutoAdAuthModal = true; // 是否为主动销毁
        this.adAuthModal.$gjDestroy();
        this.adAuthModal = null;
      }
      if(this.bindEmailModal) {
        this.isAutoBindEmailModal = true; // 是否为主动销毁
        this.bindEmailModal.$gjDestroy();
        this.bindEmailModal = null;
      }
    },
    viewLog(row) {
      this.$gjCreate('gj-log-modal', {
        props: {
          url: `/base/market/${row.id}/logs`,
          method: 'post'
        }
      });
    },
     // 首页跳转过来定位弹框
    activatedEmail(components, row) {
      const modal = this.$gjCreate(components, {
        props: {
          item: {
            countryCode: row.countryCode,
            id: row.mailId,
            marketName: row.text,
            account: row.account,
            name: row.name
          }
        },
        on: {
          after: () => {
            modal.$gjDestroy();
            //编辑提交后刷新店铺相对应的邮箱状态
            this.$emit('getEmailAccount')
          }
        }
      })
    },
    bindEmail(row) {
      const item = {
        region: row.region,
        countryCode: row.countryCode,
        marketId: row.id,
        marketName: row.marketName,
        items: row.parentItem.items
      };
      this.bindEmailModal = this.$gjCreate(AppMailAuthorizeModal, {
        props: {
          marketItem: item
        },
        on: {
          after: () => {
            this.$gjResetPage();
            this.bindEmailModal.$gjDestroy();
          },
          userGuide: () => {
            // 引导用户
            this.userGuideNextStep()
          },
          close: () => {
            if(!this.isAutoBindEmailModal && this.userGuideState) { // 非自动关闭弹框才需要退出用户指引模式
              // 关闭引导用户
              this.userGuideCancel();
              this.isAutoBindEmailModal = false;
            }
          },
        }
      })
    },
    editEmail(row) {
      const modal = this.$gjCreate(AppMailEditModal, {
        props: {
          item: {
            countryCode: row.countryCode,
            id: row.email.id,
            marketName: row.marketName,
            account: row.email.account,
            name: row.email.name
          }
        },
        on: {
          after: () => {
            this.$gjResetPage();
            modal.$gjDestroy();
          }
        }
      })
    },
    unbindEmail(id) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title:'解绑确认',
          content: '邮箱解绑后邮箱数据将会被清空，确定解绑？'
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            unbindEmail(id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
          }
        }
      })
    },
    getMailAuthErrorMsg(status) {
      if (status === 'AuthCodeError') {
        return '密码/授权码错误';
      } else if (status === 'AuthFail') {
        return '授权失败';
      } else if (status === 'AuthCodeErrorAndAuthFail') {
        return '密码/授权码错误且授权失败';
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .info-content{
  font-size: 14px;
  line-height: 1;
  margin-bottom: 6px;
  display: inline-block;
}
/deep/ .status-success {
  color: #2DA641;
}

/deep/ .status-fail {
  color: #F5222D;
}

/deep/ .handle-button {
  min-width: 56px;
  height: 32px;
}

/deep/ .country-checkbox {
  margin: 10px 0 0;
}

/deep/ .country-checkbox .el-form-item__label,
/deep/ .country-checkbox .el-form-item__content {
  line-height: 20px;
}
</style>
